import React from 'react';

import Suspense from '@atlaskit/react-ufo/suspense';

import { getIconColor } from '../skill-colors';
import type { SkillColor } from '../skill-colors';
import { DefaultSkillIcon, skillIconMap } from '../skill-icons';
import type { SkillIconName } from '../skill-icons';

type SkillIconProps = {
	color?: string | null;
	iconKey?: string | null;
	size?: 'medium' | 'small';
};

export const SkillIcon = ({
	iconKey,
	color,
	size = 'medium',
}: SkillIconProps): React.JSX.Element => {
	const IconComponent = (iconKey && skillIconMap[iconKey as SkillIconName]) || DefaultSkillIcon;
	return (
		<Suspense fallback={null} interactionName="skill-icon">
			<IconComponent label="" size={size} color={getIconColor(color as SkillColor)} />
		</Suspense>
	);
};
